/**
 * LaunchDarkly Feature Flag Configuration
 */

/**
 * LaunchDarkly environment configuration
 */
export interface LaunchDarklyConfig {
  clientSideId: string;
  isEnabled: boolean;
}

/**
 * Gets the LaunchDarkly configuration from environment variables
 */
export const getLaunchDarklyConfig = (): LaunchDarklyConfig => {
  const clientSideId = (process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || '').trim();
  
  // Valid LD client IDs are 20+ char hexadecimal strings (0-9, a-f), no spaces
  const isValidId = /^[0-9a-fA-F]+$/.test(clientSideId) && clientSideId.length >= 20;
  
  return {
    clientSideId,
    isEnabled: isValidId
  };
};

/**
 * Feature flag keys following LaunchDarkly naming conventions
 * Format: ui-<feature>-<description>-enabled
 */
export const FeatureFlags = {
  UI_ENHANCED_LOGGING_ENABLED: 'ui-enhanced-logging-enabled',
  UI_SOLEX_EDITOR_ENABLED: 'ui-solex-editor-enabled',
} as const;

/**
 * Type representing all available feature flag keys
 */
export type FeatureFlagKey = typeof FeatureFlags[keyof typeof FeatureFlags];

/**
 * Default values for feature flags when LaunchDarkly is unavailable
 */
export const FeatureFlagDefaults: Record<FeatureFlagKey, boolean> = {
  [FeatureFlags.UI_ENHANCED_LOGGING_ENABLED]: false,
  [FeatureFlags.UI_SOLEX_EDITOR_ENABLED]: false,
};

/**
 * Get the effective default value for a flag
 */
export const getEffectiveDefault = (
  flagKey: FeatureFlagKey,
  defaultValue?: boolean
): boolean => {
  return defaultValue ?? FeatureFlagDefaults[flagKey];
};
